(function () {
    'use strict';

    function sanitizeHtml(html) {
        var cleaned = '';
        if (!/script/.test(html) || !/<style/.test(html)) {
            cleaned = html;
        } else {
            cleaned = html.replace(/<script>[\s\S]*?<\/script>/, '').replace(/<style>[\s\S]*?<\/style>/, '');
        }

        return cleaned;
    }

    function addressing($scope, postCodeAnywhereService) {
        $scope.selectAddress = function () {
            postCodeAnywhereService.fetchAddressById($scope.postcode)
                .success($scope.selectAddressCallback);
        };

        $scope.getAddressesCallback = function (res) {
            $scope.addresses = res.Items;
            $scope.hasPostCodeError = false;
            $scope.showAddressList = true;
        };

        $scope.selectAddressCallback = function (res) {
            var result = res.Items[0];
            $scope.address = {};
            $scope.address.firstLine = result.Line1;
            $scope.address.secondLine = result.Line2;
            $scope.address.town = result.City;
            $scope.manualAddressEntry = true;
            $scope.showAddressList = false;
        };
    }

    angular.module('vhols')

        .controller('CustomerPagesController', ['$scope', 'postCodeAnywhereService', function ($scope, postCodeAnywhereService) {

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.signupForm.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])

        .controller('MultiCentreFormController', ['$scope', 'postCodeAnywhereService', 'dates', function ($scope, postCodeAnywhereService, dates) {
            var _EMPTY = '';
            var NOW = new Date();

            $scope.currentPage = 1;
            $scope.numPages = 2;

            $scope.monthsToShow = 24;
            $scope.date = dates(NOW).asDate();
            $scope.minDate = dates(NOW).asDate();
            $scope.maxDate = dates($scope.date).addMonths($scope.monthsToShow).asDate();


            $scope.changeDown = function(value, levels) {
                levels.forEach(function(level) {
                    $scope[level] = _EMPTY;
                });
            };

            $scope.showStop = function(stop) {
                return parseInt($scope.noStops) >= stop;
            };

            $scope.changeStops = function() {
                var numStops = parseInt($scope.noStops);

                if (!numStops || numStops < 2) {
                    $scope.firstStop = _EMPTY;
                    $scope.secondStop = _EMPTY;
                }

                if (numStops < 3) {
                    $scope.thirdStop = _EMPTY;
                }

                if (numStops < 4) {
                    $scope.fourthStop = _EMPTY;
                }
            };

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.multiCentreRequest.part_three.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])

        .controller('ToursFormController', ['$scope', 'postCodeAnywhereService', 'dates', function ($scope, postCodeAnywhereService, dates) {
            var _EMPTY = '';
            var NOW = new Date();

            $scope.currentPage = 1;
            $scope.numPages = 2;

            $scope.monthsToShow = 24;
            $scope.date = dates(NOW).asDate();
            $scope.minDate = dates(NOW).asDate();
            $scope.maxDate = dates($scope.date).addMonths($scope.monthsToShow).asDate();


            $scope.changeDown = function(value, levels) {
                levels.forEach(function(level) {
                    $scope[level] = _EMPTY;
                });
            };

            $scope.getAddresses = function () {
                try {
                    var postcode = $scope.toursRequest.part_three.postcode.$viewValue;
                    postCodeAnywhereService.postCodeLookup(postcode)
                        .success($scope.getAddressesCallback);
                } catch (e) {
                    $scope.hasPostCodeError = true;
                    $scope.addresses = null;
                }
            };

            addressing($scope, postCodeAnywhereService);
        }])

        .filter('range', function() {
            return function (input, min, max) {
                for (var i = min; i < max + 1; i++) {
                    input.push(i);
                }

                return input;
            };
        })

        .constant('CONTACT_TABS', {
            "#contact": "contact",
            "#retail": "retail",
            "#self-service": "self-service",
            "#chat": "chat"
        })
        .controller('ContactUsController', ['$scope', '$sce', '$window', 'CONTACT_TABS', function ($scope, $sce, $window, TABS) {
            $scope.tab = TABS[$window.location.hash] || "self-service";

            $scope.trackEvent = function (eventName, eventDetail) {
                if (typeof trackEvent !== 'undefined') {
                    trackEvent(eventName, eventDetail, null);
                }
            };
        }])

        .controller('ConciergeController',  ['$scope', '$sce', '$window', 'CONTACT_TABS', function ($scope, $sce, $window, TABS) {
            $scope.$watch("resort", function () {

                if ($scope.resortContacts) {
                    $scope.parentLocations = JSON.parse($scope.resortContacts);

                    $scope.parentSelect = $scope.parentLocations[0];
                    $scope.childResorts = $scope.parentSelect.children;
                    $scope.childSelect = $scope.parentSelect.children[0];
                    $scope.currentContact = $scope.childSelect;
                }
            });

            $scope.changeParent = function () {
                $scope.childResorts = $scope.parentSelect.children;
                $scope.childSelect = $scope.parentSelect.children[0];
                $scope.currentContact = $scope.childSelect;
            };

            $scope.changeChild = function () {
                $scope.currentContact = $scope.childSelect;
            };
        }])

        .controller('LiveChatController', ['$scope', function ($scope) {

            $scope.isLiveChatVisible = function (inView) {

                $scope.liveChatInView = inView;

            };
        }])

        .filter('to_trusted', ['$sce', function ($sce) {
            return function (text) {
                var cleaned = sanitizeHtml(text);
                return $sce.trustAsHtml(cleaned);
            };
        }]);
})();
